(function () {
  'use strict';

  function collectInstafeedSections(root) {
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll('.shopify-section'), function (section) {
      return Boolean(
        section.querySelector('[id*="instafeed_app_block"]') ||
        section.querySelector('#insta-feed')
      );
    });
  }

  function optimizeInstafeed(section) {
    if (!section || section.dataset.instafeedOptimized === 'true') return;

    section.dataset.instafeedOptimized = 'true';
    section.setAttribute('data-instafeed-deferred', '');

    section.querySelectorAll('#insta-feed img').forEach(function (img, index) {
      img.loading = 'lazy';
      img.decoding = 'async';
      img.fetchPriority = 'low';

      if (!img.hasAttribute('width') && img.width) img.setAttribute('width', img.width);
      if (!img.hasAttribute('height') && img.height) img.setAttribute('height', img.height);

      if (index > 3) img.style.contentVisibility = 'auto';
    });

    section.querySelectorAll('#insta-feed iframe').forEach(function (iframe) {
      iframe.loading = 'lazy';
    });
  }

  function run() {
    collectInstafeedSections(document).forEach(optimizeInstafeed);
  }

  function init() {
    run();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (
            (node.matches && (node.matches('.shopify-section') || node.matches('[id*="instafeed_app_block"]') || node.matches('#insta-feed'))) ||
            (node.querySelector && (node.querySelector('[id*="instafeed_app_block"]') || node.querySelector('#insta-feed')))
          ) {
            run();
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
